<a href="javascript:void(0)" (click)="customizeSidedrawer()" class="mb-md-max-3 icon-primary-btn">
  <span class="nxticon-settings" style="position: relative; top: 1px;"></span> {{btnTitle}}
</a>

<!--bootstrap modal window for customizing widgets-->
<ng-template #customizePopup let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="font-bold font-large"> <span class="nxticon-settings font-color-blue"></span> {{modalTitle}}
    <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
    </button>
  </h4>
  </div>
  <div class="filter-body modal-body">

    <!-- Select All (non-draggable) -->
    <div class="tab-box drag-box grab p-3 mt-3">
      <div class="in-card">
        <div class="d-flex checkbox-wrapper align-items-center">
          <img class="mr-3" [src]='dragImg'>
          <input type="checkbox" class="form-control checkbox" id="selectAll" [(ngModel)]="selectAll" (ngModelChange)="onSelectAllChange($event)" name="chk_select_all" value="1">
          <label class="checkbox-label" for="selectAll">
            <strong> Select All </strong>
          </label>
          <img class="ml-auto" [src]='dragImg'>
        </div>
      </div>
    </div>

    <div class="wrapper available-container source" dragula='bag-items' [dragulaModel]='customizeList'>

      <div *ngFor="let item of customizeList; let index = index;" class="tab-box drag-box grab p-3" >
        <div class="in-card">
          <div class="d-flex checkbox-wrapper align-items-center">
            <img class="mr-3" [src]='dragImg'>
            <input type="checkbox" class="form-control checkbox" id="item{{index}}" [(ngModel)]="item.visible" (ngModelChange)="onVisibilityChange($event, index)"  name="chk_val{{index}}" value="1"  >
            <label class="checkbox-label" for = "item{{index}}" >
              <strong> {{item.name}} </strong>
            </label>
            <img class="ml-auto" [src]='dragImg'>
          </div>
        </div>
      </div>

      
    </div>
    
    <!-- Non access insights widget names in below div for Insights discoverability -->
    <div *ngFor="let item of noAccessWidgetsLists; let index = index;" class="tab-box p-3" >
      <div class="in-card">
        <div class="d-flex checkbox-wrapper align-items-center">
          <label class="checkbox-label" for = "item.name" >
            <strong> {{item.name}} </strong>
          </label>
          <span class="ml-auto"> 
            <a href="#" class="text-link mr-4" (click)='redirectoDetailedView(item.page)'> Know more </a>
            <span class="nxticon-lock font-color-gray mr-3" style="background-color: #DDE2EE;border-radius: 50%;padding: 10px;;"></span>
          </span>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary text-uppercase" (click)="saveSettings(customizeList)"> Save </button>
  </div>

</ng-template>
